const portfolioData = [
  {
    id: 1,
    client: "Milari Organics",
    countryFlag: "/images/australia.png",
    website: "https://milariorganics.com.au/",
    caseStudy: "#",
    previewImage: "/images/projects/milari.png",
    graphImage: "/images/projects/malari_graph.png",
    tableImage: "/images/projects/milari_table.png",
    keywords: [
      { keyword: "escorted golf tours", initial: "Not in 100", current: 1 },
      { keyword: "golf group tours", initial: "Not in 100", current: 3 },
      { keyword: "golf travel agency", initial: "Not in 100", current: 8 },
    ],
  },
  {
    id: 2,
    client: "Alpine Print",
    countryFlag: "/images/new-zealand.png",
    website: "https://www.alpineprint.nz/",
    caseStudy: "#",
    previewImage: "/images/projects/alpine.png",
    graphImage: "/images/projects/alpine_graph.png",
    tableImage: "/images/projects/alpine_table.png",
    keywords: [
      { keyword: "electric atv", initial: "Not in 100", current: 1 },
      { keyword: "kids electric bike", initial: "Not in 100", current: 2 },
    ],
  },
  {
    id: 3,
    client: "Premium Bond Cleaning",
    countryFlag: "/images/australia.png",
    website: "https://premiumbondclean.com.au/",
    caseStudy: "#",
    previewImage: "/images/projects/premiumBond.png",
    graphImage: "/images/projects/premiumBond_graph.png",
    tableImage: "/images/projects/premiumBond_table.png",
    keywords: [
      { keyword: "electric atv", initial: "Not in 100", current: 1 },
      { keyword: "kids electric bike", initial: "Not in 100", current: 2 },
    ],
  },
  {
    id: 4,
    client: "Boost Commercial Cleaning",
    countryFlag: "/images/australia.png",
    website: "https://boostcommercialcleaning.com.au/",
    caseStudy: "#",
    previewImage: "/images/projects/boostCommercial.png",
    graphImage: "/images/projects/boost_commercial_graph.png",
    // tableImage: "/images/projects/premiumBond_table.png",
    keywords: [
      { keyword: "electric atv", initial: "Not in 100", current: 1 },
      { keyword: "kids electric bike", initial: "Not in 100", current: 2 },
    ],
  },
];

export default portfolioData;
